// https://blog.andrewjamesbibby.com/2019/08/01/cancel-all-pending-axios-requests-in-vue-spa-on-router-change/
import Vue from 'vue'
import Router from 'vue-router'
import { desktopRoutes } from '@/router/routes/desktopRoutes'
import { mobileRoutes } from '@/router/routes/mobileRoutes'
import { partnerGuard } from '@/router/guards/partner-guard'
import { trackViewPageGuard } from '@/router/guards/track-view-page-guard'
import { spinnerGuard } from '@/router/guards/spinner-guard'
import { userTypeGuard } from '@/router/guards/userType-guard'
import { alertsGuard } from '@/router/guards/alerts-guard'
import { searchIAGuard } from '@/router/guards/search-ia-guard'
import { setPageTitleGuard } from '@/router/guards/set-page-title-guard'
import { cancelRequestGuard } from '@/router/guards/cancel-request-guard'
import { menuGuard } from '@/router/guards/menu-guard'
import { historyGuard } from './guards/history-guard'
import { loginRoutes } from '@/router/routes/shared/loginRoutes'
import { sharedRoutes } from '@/router/routes/shared/sharedRoutes'
import { loginNoRequiresAuth } from '@/router/guards/login-no-requires-auth'

Vue.use(Router)

const initialRoutes = [...desktopRoutes, ...mobileRoutes, ...sharedRoutes, ...loginRoutes]

export const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: initialRoutes
})

router.beforeEach(partnerGuard) // Partner token

router.beforeEach(loginNoRequiresAuth) // Redirect when login urls no require auth
router.beforeEach(userTypeGuard) // Lex-ON DMS: Redirect to repository

// info guards
router.beforeEach(trackViewPageGuard) // *** Track view page *********************************************************
router.beforeEach(setPageTitleGuard) // Set page title
router.beforeEach(cancelRequestGuard) // Cancel pending request

// no mobile
router.beforeEach(spinnerGuard) // Show spinner before every page load
router.beforeEach(alertsGuard) // Update app. alerts
router.beforeEach(menuGuard) // Show menu by type
router.beforeEach(historyGuard) // Save last route
router.beforeEach(searchIAGuard) // Search IA: Block access if not enabled
